module.exports = __webpack_public_path__ + "static/assets/1336f72e4f1b886d878d8c7dbb6d33a8.svg";